import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import RegionBadges from './components/RegionBadges';
import { WhyClean, ForBusiness } from './components/Sections';
import Services from './components/Services';
import BeforeAfter from './components/BeforeAfter';
import { Process, Areas } from './components/ProcessAreas';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';
import ContactForm from './components/ContactForm';
import { FinalCta, Footer } from './components/FooterCta';
import WhatsAppButton from './components/WhatsAppButton';
import PromoPopup from './components/PromoPopup';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Admin from './pages/Admin';
import { Toaster } from './components/ui/toaster';

const Landing = () => (
  <div className="App">
    <Header />
    <main>
      <Hero />
      <RegionBadges />
      <WhyClean />
      <Services />
      <BeforeAfter />
      <WhyUsStats />
      <ForBusiness />
      <Process />
      <Areas />
      <Testimonials />
      <Faq />
      <ContactForm />
      <FinalCta />
    </main>
    <Footer />
    <WhatsAppButton />
    <PromoPopup />
  </div>
);

function WhyUsStats() {
  const stats = [
    { n: '15+', t: 'Leistungen aus einer Hand' },
    { n: '11', t: 'Regionen deutschlandweit' },
    { n: '100%', t: 'Ehrliche Einschätzung' },
    { n: '24/7', t: 'Winterdienst möglich' },
  ];
  return (
    <section id="warum" className="py-20 md:py-24 bg-[#0B1E44] text-white relative overflow-hidden">
      <div className="absolute inset-0 dotted-bg opacity-15" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="crown-divider text-[#E0A72C]">Warum wir</span>
          <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight">
            Ein Ansprechpartner. <span className="gold-text">Saubere Ergebnisse.</span>
          </h2>
          <p className="mt-5 text-white/75 text-lg">
            Die Haushelden kombinieren Reinigung, Sanierung und Objektpflege in einem Angebot – klar abgestimmt, zuverlässig umgesetzt und passend zum Objekt geplant.
          </p>
        </div>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {stats.map((s, i) => (
            <div key={i} className="rounded-2xl border border-white/10 bg-white/5 p-6 hover:border-[#E0A72C]/60 transition-colors">
              <div className="text-4xl md:text-5xl font-extrabold gold-text">{s.n}</div>
              <div className="mt-2 text-white/80 text-sm">{s.t}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
